import type { CompanySsoPublicConfig } from './ApiService';

export const SIGN_IN_BOOTSTRAP_TIMEOUT_MS = 8000;

const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

/** A successful tenant lookup is required before deciding which login methods exist. */
export const resolvePublicSignInSso = (client: unknown): CompanySsoPublicConfig | null => {
  if (!isRecord(client) || typeof client.EntryId !== 'string' || !client.EntryId.trim() ||
      !isRecord(client.Information)) {
    throw new Error('invalid_public_sign_in_identity');
  }

  // Legacy tenants can explicitly return an Information object without SSO.
  if (!Object.prototype.hasOwnProperty.call(client.Information, 'SSO')) return null;
  const sso = client.Information.SSO;
  if (!isRecord(sso) || typeof sso.Enabled !== 'boolean') {
    throw new Error('invalid_public_sign_in_policy');
  }
  if (!sso.Enabled) return null;
  if (typeof sso.LoginMode !== 'string' || !['disabled', 'optional', 'enforced'].includes(sso.LoginMode) ||
      (sso.LoginMode === 'enforced' && typeof sso.AllowPasswordFallback !== 'boolean') ||
      (sso.AllowPasswordFallback !== undefined && typeof sso.AllowPasswordFallback !== 'boolean') ||
      (sso.ProviderName !== undefined && typeof sso.ProviderName !== 'string') ||
      (sso.DisplayName !== undefined && typeof sso.DisplayName !== 'string') ||
      (sso.ProviderType !== undefined && (typeof sso.ProviderType !== 'string' || !['OIDC', 'SAML'].includes(sso.ProviderType))) ||
      (sso.Cognito !== undefined && (!isRecord(sso.Cognito) ||
        (sso.Cognito.ProviderName !== undefined && typeof sso.Cognito.ProviderName !== 'string')))) {
    throw new Error('invalid_public_sign_in_policy');
  }
  return sso as unknown as CompanySsoPublicConfig;
};
